{
	"password": "Senha",
	"confirmPassword": "Confirmação de senha",
	"passwordToggle": {
		"show": "Mostrar senha",
		"hide": "Ocultar senha"
	}
}
